
export const config = {
    trackingId: 'UA-69748662-5'
  }